import { StaffActionTypes, } from './types';
import { createAsyncAction, createAsyncMapAction } from '~lib/shared/redux/actions';
export const listBadges = createAsyncAction(StaffActionTypes.LIST_BADGES);
export const listStaff = createAsyncMapAction(StaffActionTypes.LIST_STAFF, p => p.showPastEmployees.toString());
export const listStaffPublic = createAsyncAction(StaffActionTypes.LIST_STAFF_PUBLIC);
export const getStaffById = createAsyncMapAction(StaffActionTypes.GET_STAFF_BY_ID, p => p.userId);
export const getStaffBySlug = createAsyncMapAction(StaffActionTypes.GET_STAFF_BY_SLUG, p => p.slug);
export const upsertStaffMember = createAsyncMapAction(StaffActionTypes.UPSERT_STAFF_MEMBER, p => p.requestId);
export const disableStaffMember = createAsyncMapAction(StaffActionTypes.DISABLE_STAFF_MEMBER, p => p.requestId);
